import Fantastic from "./home";

export default Fantastic;